import {Component, CUSTOM_ELEMENTS_SCHEMA, ViewEncapsulation} from '@angular/core';
import {CarouselModule} from "primeng/carousel";

declare global {
    interface Window { swiperEl: any; }
}

@Component({
    selector: 'app-elite-athletes',
    templateUrl: './elite-athletes.component.html',
    styleUrls: ['./elite-athletes.component.scss'],
    imports: [
        CarouselModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    standalone: true,
})
export class EliteAthletesComponent {
    images_slider = [
        { imgSrc: 'assets/images/athletes/adam-moussa.jpg', name: 'Adam Moussa', title: 'IFBBPro Classic Physique', description: 'Nutrigenic elevates our entire programme, ensuring every athlete is fuelled for success' },
        { imgSrc: 'assets/images/athletes/chayanne-evans-gray.jpg', name: 'Chayanne Evans Gray', title: 'Team GB – Track Athelete', description: 'With Nutrigenic, I’m lighter on my feet and sharper in my sprints—pure performance, no compromise' },
        { imgSrc: 'assets/images/athletes/farid-basharat.jpg', name: 'Farid Basharat', title: 'UFC Fighter', description: 'Nutrigenic gives me the edge I need—clean, powerful fuel that keeps me going strong in the cage.' },
        { imgSrc: 'assets/images/athletes/jason-long.jpg', name: 'Jason Long', title: 'Pro Athlete’s Coach', description: 'My athletes trust Nutrigenic for a reason: it’s reliable, nutritious, and consistently elevates their game.' },
        { imgSrc: 'assets/images/athletes/lily-ella-dolling.jpg', name: 'Lily Ella Dolling', title: 'Boxing English Champion', description: 'Nutrigenic fuels my training camp with balanced nutrition—I stay strong and focused round after round.' },
        { imgSrc: 'assets/images/athletes/marky-james.jpg', name: 'Marky James', title: 'IFBBPro Classic Physique', description: 'Consistent quality meals mean I can bulk, cut, or maintain shape with absolute confidence.' },
        { imgSrc: 'assets/images/athletes/yaser-al-ghena.jpg', name: 'Yaser Al Ghena', title: 'Boxing English Champion', description: 'Nutrigenic keeps me sharp, powerful, and ready to strike—real fuel for every fight.' },
    ];

    ngAfterViewInit() {
        const swiperEl: any = document.querySelector('swiper-container');
        swiperEl.initialize(); // manually initialize since init="false"
    }

}
